<div class=" mt-4">
    
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div>
                                <div class="text-center">
                                    <a class="view-h gary-t">View BulkUpload File Detail</a>
  
                                </div>
  
                                <div class="pt-3">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class=" ">
                                              <!-- <div class="row mb-3">
                    
                                                  <div class="col-4 p-0"> <label>PayOut Bulk FileId</label> </div>
                                                  
                                                  <div class="col-7 p-0 view-text robot"> {{rows.PayOutBulkFileId}}
                                                                                   </div>
                                              </div> -->
                                              <div class="row mb-3">
                    
                                                  <div class="col-4 p-0"> <label>PayOut Beneficiary KeyId</label> </div>
                                                  
                                                  <div class="col-7 p-0 view-text robot"> {{rows.PayOutBeneficiaryKeyId}}</div>
                                              </div>
                                              <div class="row mb-3">
                    
                                                <div class="col-4 p-0"> <label>Payout Customer keyId</label> </div>
                                                
                                                <div class="col-7 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}</div>
                                            </div>
                                              <div class="row mb-3">
                    
                                                  <div class="col-4 p-0"> <label>Amount</label>  </div>
                                                  
                                                  <div class="col-7 p-0 view-text"> {{rows.Amount | currency:"₹"}}</div>
                                              </div>
                                              <div class="row mb-3">
                    
                                                  <div class="col-4 p-0"> <label> Payment Type</label></div>
                                                  
                                                  <div class="col-7 p-0 view-text robot"> {{rows.PaymentType}}</div>
                                              </div> 
                                              
                                              <div class="row mb-3" *ngIf="Transactiondetail">
                    
                                                <div class="col-4 p-0"> <label>PayOut Transaction Id</label></div>
                                                
                                                <div class="col-7 p-0 view-text robot"> {{rows.PayOutTransactionId}}</div>
                                            </div> 
                                              <div class="row mb-3">
                    
                                                <div class="col-4 p-0"> <label>Note</label></div>
                                                
                                                <div class="col-7 p-0 view-text robot"> {{rows.notes}}</div>
                                            </div>                        
                                            <div class="row mb-3" *ngIf="Transactiondetail">
                    
                                                <div class="col-4 p-0"> <label>Response Text</label></div>
                                                
                                                <div class="col-7 p-0 view-text robot"> {{rows.ResponseText}}</div>
                                            </div> 
                    
                                            <div class="row mb-3" *ngIf="Transactiondetail">
                    
                                                <div class="col-4 p-0"> <label>Reference No </label></div>
                                                
                                                <div class="col-7 p-0 view-text robot"> {{rows.ReferenceNo}}</div>
                                            </div> 
                    
                                            
                                          <div class="row mb-3">
                    
                                                  <div class="col-4 p-0"> <label>Status</label>  </div>
                                                  
                                                  <!-- <div class="col-7 p-0 view-text"> {{rows.Status}}</div> -->
                    
                                                  <div class="col-7 p-0 view-text text-warning" *ngIf="rows.Status==0"> 
                                                    Pending
                                                   </div>
                                                   <div class="col-7 p-0 view-text text-approved" *ngIf="rows.Status==1"> 
                                                    Approved
                                                   </div>
                                                   <div class="col-7 p-0 view-text text-danger" *ngIf="rows.Status==2"> 
                                                    Failed
                                                   </div>
                                                   <div class="col-7 p-0 view-text text-approved" *ngIf="rows.Status==3"> 
                                                    Completed
                                                   </div>
                                              </div>
                                              <!-- <div class="row mb-3">
                    
                                                  <div class="col-4 p-0"><label> Response Code </label>  </div>
                                                  
                                                  <div class="col-7 p-0 view-text robot"> {{rows.ResponseCode}}</div>
                                              </div> -->
                                              <!-- <div class="row mb-3">
                    
                                                  <div class="col-4 p-0"> <label> Response Text </label>  </div>
                                                  
                                                  <div class="col-7 p-0 view-text"> {{rows.ResponseText}}</div>
                                              </div>
                                              <div class="row mb-3">
                    
                                                  <div class="col-4 p-0"> <label> ReferenceNo</label>  </div>
                                                  
                                                  <div class="col-7 p-0 view-text robot">   {{rows.ReferenceNo }}</div>
                                              </div> -->
                                              <div class="row mb-3">
                    
                                                  <div class="col-4 p-0"> <label>Date Time</label>  </div>
                                                  
                                                  <div class="col-7 p-0 view-text robot"> {{rows.LastUpdateDatetime | date:'d/M/yy, h:mm a'}}</div>
                                              </div>
                                              <!-- <div class="row mb-3">
                    
                                                <div class="col-4 p-0"> <label>Approval Status</label>  </div>
                                                
                                                <div class="col-7 p-0 view-text robot"> {{rows.ApprovalStatus}}</div>
                                            </div>
                                            <div class="row mb-3">
                    
                                              <div class="col-4 p-0"> <label>ApprovedBy</label>  </div>
                                              
                                              <div class="col-7 p-0 view-text robot"> {{rows.ApprovedBy}}</div>
                                          </div> -->
                                          <!-- <div class="row mb-3">
                    
                                            <div class="col-4 p-0"> <label>UploadDateTime</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.UploadDateTime | date:'d/M/yy, h:mm a'}}</div>
                                        </div>
                                             -->
                                              <div class="row m-1 text-right">
                                                 
                                                
                                              </div>
                                          </div>
                                          </div>
                                    </div>
                                </div>
  
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </section>
  </div>
  







 